import React, { ChangeEvent, useEffect, useState } from 'react';

interface RechartsColorInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value?: string;
  onColorChange: (value: string) => void; // Rinominata da onChange
  // className è già incluso in React.InputHTMLAttributes<HTMLInputElement>
}

const RechartsColorInput: React.FC<RechartsColorInputProps> = ({
  value: initialValue = '#000000', // Default to black if no value is provided
  onColorChange, // Rinominata da onChange
  className,
  ...rest
}) => {
  const [color, setColor] = useState<string>(initialValue);

  useEffect(() => {
    // Assicura che il valore iniziale sia un esadecimale valido, altrimenti usa il default
    const isValidHex = /^#[0-9A-F]{6}$/i.test(initialValue);
    setColor(isValidHex ? initialValue : '#000000');
  }, [initialValue]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newColor = event.target.value;
    setColor(newColor);
    if (onColorChange) {
      onColorChange(newColor); // L'input type="color" restituisce già #rrggbb
    }
  };

  return (
    <input
      type="color"
      value={color}
      onChange={handleChange}
      className={className}
      {...rest}
    />
  );
};

export default RechartsColorInput;